import React, { Component } from 'react';

type Props = {
  title: string;
  // query is the search query (key concept) being searched for that we are highlighting for related searches
  query: string | null;
  workId: number | string;
};

/* Displays the title of the work, does highlighting if it is available.
 *
 */
class Title extends Component<Props> {
  componentDidMount() {
    if (this.props.query) {
      this.highlightText();
    }
  }

  componentDidUpdate() {
    if (this.props.query) {
      this.highlightText();
    }
  }

  highlightText() {
    // Doing highlights after text is rendered to prevent XSS vulnerabilities
    const query = this.props.query;
    const queryRegex = new RegExp(`(\\b)${query}(\\b|('?s\\b))`, 'ig');
    const abstractSpan = document.querySelector(
      `#work-title-${this.props.workId}`,
    ) as Element;
    const currentHtml = abstractSpan.innerHTML;
    abstractSpan.innerHTML = currentHtml.replace(queryRegex, (text) =>
      this.addStrongTag(text),
    );
  }

  addStrongTag(text: string) {
    return `<strong>${text}</strong>`;
  }

  render() {
    return (
      <div className="work-card--title" id={`work-title-${this.props.workId}`}>
        {this.props.title}
      </div>
    );
  }
}

export default Title;
